// Encode targets come from msb-api GET video-profiles, so the curve lives in one
// place. The values here are only a fallback for when that request fails.

export const VIDEO_TYPES = { LIBRARY: "library", SET_VIDEO: "setVideo" };

const FALLBACK = {
  curve: {
    referenceBitrate: 3_000_000,
    referenceWidth: 1920,
    referenceHeight: 1080,
    exponent: 0.95,
  },
  profiles: {
    [VIDEO_TYPES.LIBRARY]: {
      maxLongEdge: 1920,
      quality: 2,
      frameRate: 30,
      audioBitrate: 128_000,
      audioSampleRate: 48_000,
      audioChannels: 2,
    },
  },
};

let cached = null;
let inFlight = null;

/**
 * Fetch and cache the profiles. Unauthenticated on purpose — the route is public
 * config and this runs at file-pick, before any upload token exists. Never throws:
 * a failure keeps the previous value, or the fallback.
 */
export function loadVideoProfiles() {
  if (cached) return Promise.resolve(cached);
  // Concurrent picks share one request rather than racing.
  inFlight ??= fetch("/api/video-profiles")
    .then((res) => (res.ok ? res.json() : null))
    .then((body) => {
      if (body?.profiles && body?.curve) cached = body;
      return cached ?? FALLBACK;
    })
    .catch((error) => {
      console.warn("[video-profiles] falling back to defaults", error.message);
      return FALLBACK;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

/** The server's target for a video type, in the shape transcodeVideo expects. */
export function videoProfileFor(type = VIDEO_TYPES.LIBRARY) {
  const { profiles, curve } = cached ?? FALLBACK;
  const profile = profiles[type] ?? FALLBACK.profiles[VIDEO_TYPES.LIBRARY];
  return { ...profile, curve };
}
